import React, { useState, useEffect } from "react";
import { Container, Row, Col, Spinner } from "reactstrap"; // Import Spinner
import ProductCard from "./ProductCard";
import ProductModal from "./ProductModal";

const CATEGORY_MAP = {
  70: "Bagel",
  74: "Cold Drinks",
  72: "Cold Floats",
  71: "Frozen Desserts",
  75: "Hot Drinks",
  73: "Hot Floats",
};

const OrderMenu = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [addonQuantities, setAddonQuantities] = useState({});

  const toggleModal = () => setModal(!modal);

  const API_URL = process.env.REACT_APP_API_URL;

  const fetchProducts = async () => {
    try {
      const response = await fetch(`${API_URL}?vendor_id=30`);
      const data = await response.json();
      if (data.success) {
        const formattedProducts = data.data.map((product) => ({
          id: product.id,
          title: product.name,
          price: parseFloat(product.price),
          image: product.images?.[0] || "https://via.placeholder.com/200",
          categoryId: product.categories?.[0]?.id,
          categoryName: product.categories?.[0]?.name,
          addons: Object.keys(product.addons || {}).map((key) => ({
            id: key,
            type: product.addons[key].type,
            title: product.addons[key].title,
            data_name: product.addons[key].data_name,
            price: parseFloat(product.addons[key].price || 0),
            options: product.addons[key].options || [],
          })),
        }));
        setProducts(formattedProducts);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const handleProductClick = (product) => {
    if (!product.addons || product.addons.length === 0) {
      // Direct form submission for products without addons
      const form = document.createElement("form");
      form.method = "POST";
      form.action = "https://tealbo.com/vendor-carts";

      const productInput = document.createElement("input");
      productInput.type = "hidden";
      productInput.name = "add-to-cart";
      productInput.value = product.id;
      form.appendChild(productInput);

      const priceInput = document.createElement("input");
      priceInput.type = "hidden";
      priceInput.name = "total_price";
      priceInput.value = parseFloat(product.price).toFixed(2);
      form.appendChild(priceInput);

      document.body.appendChild(form);
      form.submit();
    } else {
      // Open modal for products with addons
      setSelectedProduct(product);
      const initialQuantities = product.addons.reduce((acc, addon) => {
        acc[addon.id] = 0;
        return acc;
      }, {});
      setAddonQuantities(initialQuantities);
      toggleModal();
    }
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
        }}
      >
        <Spinner color="primary" size="sm" />
        <p style={{ marginTop: "10px", fontSize: "1.2rem" }}>
          Loading products...
        </p>
      </div>
    );
  }

  // Group products by categories
  const groupedProducts = products.reduce((acc, product) => {
    const categoryId = product.categoryId;
    if (!acc[categoryId]) {
      acc[categoryId] = [];
    }
    acc[categoryId].push(product);
    return acc;
  }, {});

  return (
    <Container>
      {Object.keys(CATEGORY_MAP).map((categoryId) => {
        const categoryProducts = groupedProducts[categoryId] || [];
        if (categoryProducts.length === 0) return null; // Skip empty categories

        return (
          <div key={categoryId} style={{ marginBottom: "2rem" }}>
            <h2 style={{ textAlign: "left", marginBottom: "1rem" }}>
              {CATEGORY_MAP[categoryId]}
            </h2>
            <Row>
              {categoryProducts.map((product) => (
                <Col md="4" key={product.id} className="mb-4">
                  <ProductCard
                    product={product}
                    onClick={() => handleProductClick(product)}
                  />
                </Col>
              ))}
            </Row>
          </div>
        );
      })}
      {selectedProduct && (
        <ProductModal
          modal={modal}
          toggleModal={toggleModal}
          product={selectedProduct}
          addonQuantities={addonQuantities}
          setAddonQuantities={setAddonQuantities}
        />
      )}
    </Container>
  );
};

export default OrderMenu;
